import Stack from "@/components/ui/stack";
import { Spinner, Text } from "@radix-ui/themes";

export default function Loading() {
  return (
    <Stack
      gap={"16px"}
      justify={"center"}
      className="items-center w-full h-screen "
    >
      <Spinner
        size={"3"}
        className="animate-spin text-gray-700 dark:text-white"
      />
      <Text
        size="5"
        weight="bold"
        className="text-gray-700 dark:text-white tracking-wide"
        style={{ letterSpacing: 2 }}
      >
        Loading...
      </Text>
    </Stack>
  );
}
